import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import fundReducer from '../features/funds/fundSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    funds: fundReducer,
  },
});

